import React from 'react';
import { Link } from 'react-router-dom';
import {
  MapPinIcon,
  PhoneIcon,
  EnvelopeIcon,
  ClockIcon,
} from '@heroicons/react/24/outline';
import {
  FaWhatsapp,
  FaLinkedin,
  FaFacebook,
  FaInstagram,
} from 'react-icons/fa';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'About Us', href: '/about' },
    { name: 'Services', href: '/services' },
    { name: 'Industries', href: '/industries' },
    { name: 'Blog', href: '/blog' },
    { name: 'Contact', href: '/contact' },
    { name: 'Testimonials', href: '/testimonials' },
  ];

  const services = [
    'Tax Planning & Filing',
    'GST Compliance',
    'Audit & Assurance',
    'Business Registration',
    'Financial Consulting',
    'NRI Tax Services',
  ];

  return (
    <footer className="bg-naqd-primary text-white border-t border-white/10">
      <div className="container-custom section-padding">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <Link to="/">
                <img
                  src="/assets/logo.png"
                  alt="NAQD Consulting"
                  className="h-12 w-auto brightness-0 invert"
                />
              </Link>
            </div>
            <p className="text-gray-400 text-sm mb-4">
              Leading chartered accountancy firm in Malappuram, Kerala, providing
              comprehensive financial and taxation services with digital-first
              approach and local expertise.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://wa.me/919074286763"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-naqd-green transition-colors"
              >
                <FaWhatsapp className="w-5 h-5" />
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-naqd-green transition-colors"
              >
                <FaLinkedin className="w-5 h-5" />
              </a>
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-naqd-green transition-colors"
              >
                <FaFacebook className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="text-gray-300 hover:text-naqd-green text-sm transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-semibold mb-4">Our Services</h3>
            <ul className="space-y-2">
              {services.map((service) => (
                <li key={service}>
                  <Link
                    to="/services"
                    className="text-gray-300 hover:text-naqd-green text-sm transition-colors"
                  >
                    {service}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold mb-4">Contact Info</h3>
            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <MapPinIcon className="w-5 h-5 text-naqd-green mt-0.5 flex-shrink-0" />
                <div className="text-sm text-gray-300">
                  <p>2nd floor, Span building</p>
                  <p>Opp. Kendra Vidyalaya, AK Road</p>
                  <p>Malappuram, Kerala 676505</p>
                </div>
              </div>
              <div className="flex items-center space-x-3">
                <PhoneIcon className="w-5 h-5 text-naqd-green flex-shrink-0" />
                <a
                  href="tel:+919074286763"
                  className="text-sm text-gray-300 hover:text-naqd-green transition-colors"
                >
                  +91 90742 86763
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <EnvelopeIcon className="w-5 h-5 text-naqd-green flex-shrink-0" />
                <a
                  href="mailto:info@naqd.in"
                  className="text-sm text-gray-300 hover:text-naqd-green transition-colors"
                >
                  info@naqd.in
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <ClockIcon className="w-5 h-5 text-naqd-green flex-shrink-0" />
                <span className="text-sm text-gray-300">Mon - Sat: 9:30 AM - 6:00 PM</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8 mt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-sm text-gray-400 mb-4 md:mb-0">
              © {currentYear} NAQD Consulting Private Limited. All rights reserved.
            </p>
            <div className="flex space-x-6 text-sm">
              <Link to="/privacy" className="text-gray-400 hover:text-naqd-green">
                Privacy Policy
              </Link>
              <Link to="/terms" className="text-gray-400 hover:text-naqd-green">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;